import React, { useState, useEffect } from "react";
import { designValue, createDesignValue, deleteDesignValue, getDesignValue, actList, getActValue, deleteActValue } from '@/services/design';
import { realtime, realtimeHours } from '@/services/common';
import { Spin, Button, DatePicker, Popconfirm } from 'antd';
import { DeleteOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";
import userInfo from "@/Components/user";
import "./DesignTree.less";
import Drawer from '@/Components/Drawer';
import DesignValue from "@/Components/DesignValue/DesignValue";
import ActValue from "@/Components/ActValue";

interface DesignTreeProps {
  creatDesVariable: number;
  isCreatDes: () => void;
  creatDesType: string;
  refreshDesVariable?: number;
  taskListWidth?: number;
}

const DesignTree: React.FC<DesignTreeProps> = ({ creatDesVariable, isCreatDes, creatDesType, refreshDesVariable, taskListWidth }) => {
  const params = useParams<{ k: string; f: string; j: string }>();
  const [dataList, setDataList] = useState<any[]>([]);
    // const [dataList, setDataList] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [drawOpen, setDrawOpen] = useState(false);
  // 用来保存当前选中的项（实现高亮）
  const [selectedItem, setSelectedItem] = useState<any>(null);
  // 当前选中项的详情数据（实际值存储项点击后通过 getActValue 获取，格式 { input, output }）
  const [realtimeData, setRealtimeData] = useState<any>(null);
  // 时间段查询时按小时聚类的数据（realtime_hours 返回 results，供抽屉内折线图使用）
  const [hourlyResults, setHourlyResults] = useState<any[]>([]);
  const [filterType, setFilterType] = useState<'all' | 'design' | 'actual'>('all');
  // 实际值存储列表（actList 接口获取，[{ id, name }]）
  const [actListData, setActListData] = useState<any[]>([]);
  // 时间段查询（独立）：选好时间直接查询，不再弹窗
  const [queryRange, setQueryRange] = useState<any>(null);
  const [queryLoading, setQueryLoading] = useState(false);
  const fetchAllData = async () => {
    setLoading(true);
    try {
      const designRes = await designValue(
        { flow_id: params.f },
        userInfo.access_token
      );
      console.log("设计值列表：", designRes.data);
      setDataList(designRes.data || []);
    } catch (err) {
      console.error("获取数据失败：", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchAllData();
    fetchActList();
  }, []);
  // 获取实际值存储列表
  const fetchActList = async () => {
    try {
      const res = await actList(userInfo.access_token);
      // 返回结构为 { records: [{ id, name }] }
      setActListData(res.data?.records || []);
      console.log("实际值存储列表:", res.data);
    } catch (err) {
      console.error("获取实际值存储列表失败", err);
      setActListData([]);
    }
  };
  const fetchItemById = async (id) => {
    try {
      const res = await getDesignValue(id, userInfo.access_token);
      return res.data;
    } catch (err) {
      console.error("获取详情失败", err);
      return null;
    }
  };

  useEffect(() => {
    if (refreshDesVariable && refreshDesVariable > 0) {
      fetchAllData();
    }
  }, [refreshDesVariable]);

  useEffect(() => {
    if (creatDesVariable > 0 && creatDesType) {
      creatDes();
    }
  }, [creatDesVariable]);

  //创建设计值函数
  const creatDes = async () => {
    //此处写创建设计值的逻辑
    console.log("creatDesType:", creatDesType);  //creatDesType值"设计"时输入设计值，为"实际"时输入实际值
    // if(creatDesType==="设计")
    // {
    //     const data={
    //         flow_id:params.f,
    //         type:"design",
    //         values:design_values,
    //     }
    //     createDesignValue(data,userInfo.access_token).then(res => {
    //         console.log("createDesignValue", res.data);
    //         // 刷新数据列表
    //         fetchAllData();
    //     })
    // }
    // else if(creatDesType==="实际")
    // {
    //     const data={
    //         flow_id:params.f,
    //         type:"actual",
    //         values:design_values,
    //     }
    //     createDesignValue(data,userInfo.access_token).then(res => {
    //         console.log("createDesignValue", res.data);
    //         // 刷新数据列表
    //         fetchAllData();
    //     })
    // }
    //当设计值创建完毕（不论成功或者失败）
    isCreatDes();
  }
  const handleItemClick = async (item: any) => {
    setHourlyResults([]); // 非时间段查询的数据不展示按小时折线图
    if (item.isFixed) {
      setSelectedItem(item);
      setDrawOpen(true);
      // 实际值存储项：通过 getActValue 按 id 获取存储的实际值数据
      try {
        const res = await getActValue(item.storeId, userInfo.access_token);
        setRealtimeData(res.data.result);
        console.log("实际值详情:", res.data);
      } catch (err) {
        console.error("获取实际值详情失败:", err);
      }
      return;
    }
    const fullItem = await fetchItemById(item.id);
    if (fullItem) {
      setSelectedItem(fullItem);
      setDrawOpen(true);
    }
  };

  // 抽屉内创建工况成功后：刷新列表并跳转到新建的这一项（与点击列表项一致）
  const handleActCreated = (created?: { id?: any; name?: string }) => {
    fetchActList();
    if (!created?.id) return;
    handleItemClick({
      id: `act-${created.id}`,
      storeId: created.id,
      type: "actual",
      isFixed: true,
      name: created.name,
      label: created.name,
    });
  };

  // 时间段查询实际数据：选好起止时间后调用 realtime 接口，查询结果直接打开抽屉展示
  const handleQueryConfirm = async () => {
    if (!queryRange || !queryRange[0] || !queryRange[1]) return;
    const startTime = dayjs(queryRange[0]).format("YYYY-MM-DDTHH:mm:ss");
    const endTime = dayjs(queryRange[1]).format("YYYY-MM-DDTHH:mm:ss");
    setQueryLoading(true);
    try {
      // 同时取整体查询结果与按小时聚类结果（后者用于抽屉顶部折线图）
      const [res, hourRes] = await Promise.all([
        realtime({ startTime, endTime }, userInfo.access_token),
        realtimeHours({ startTime, endTime }, userInfo.access_token),
      ]);
      console.log("时间段查询数据:", res.data);
      console.log("按小时聚类数据:", hourRes.data);
      setRealtimeData(res.data);
      setHourlyResults(hourRes.data?.results || []);
      // 用虚拟项作为当前选中项，让抽屉按“实际值”渲染 ActValue
      setSelectedItem({
        id: `query-${Date.now()}`,
        type: "actual",
        isFixed: true,
        // 标题展示只到小时（请求参数仍用所选精确时间）
        label: `查询 ${dayjs(queryRange[0]).format("YYYY-MM-DD HH:00")} ~ ${dayjs(
          queryRange[1]
        ).format("YYYY-MM-DD HH:00")}`,
      });
      setDrawOpen(true);
    } catch (err) {
      console.error("时间段查询失败:", err);
    } finally {
      setQueryLoading(false);
    }
  };

  const renderListItem = (item: any, index: number) => {
    // 判断是否选中
    const isActive = selectedItem?.id === item.id;
    return (
      <div
        key={index}
        className={`listItem ${isActive ? "active" : ""}`}
        onClick={(e) => {
          // 点击删除确认气泡（确定/取消）或删除图标时，不触发"点击查看"
          const target = e.target as HTMLElement;
          if (target.closest?.(".ant-popover") || target.closest?.("[data-list-no-click]")) return;
          handleItemClick(item);
        }}
        style={{ cursor: 'pointer' }}
      >
        {/* {item.type === "design" ? "设计值" : "实际值"} {index + 1} */}
        {item.isFixed ? item.label : `${item.type === "design" ? "设计值" : "实际值"} ${item.id}`}
        {item.isFixed && item.storeId && (
          <Popconfirm
            title="确定删除该实际值？"
            okText="删除"
            cancelText="取消"
            onConfirm={() => {
              deleteActValue(item.storeId, userInfo.access_token).then(res => {
                console.log("deleteActValue", res.data);
                // 若删除的是当前展示的项，关闭抽屉
                if (selectedItem?.storeId === item.storeId) setDrawOpen(false);
                // 刷新实际值存储列表
                fetchActList();
              })
            }}
          >
            <span data-list-no-click onClick={(e) => e.stopPropagation()}>
              <DeleteOutlined style={{ color: "red" }} />
            </span>
          </Popconfirm>
        )}
        {!item.isFixed && (
          <Popconfirm
            title="确定删除该设计值？"
            okText="删除"
            cancelText="取消"
            onConfirm={() => {
              deleteDesignValue(item.id, userInfo.access_token).then(res => {
                console.log("deleteDesignValue", res.data);
                // 刷新数据列表
                fetchAllData();
              })
            }}
          >
            <span data-list-no-click onClick={(e) => e.stopPropagation()}>
              <DeleteOutlined style={{ color: "red" }} />
            </span>
          </Popconfirm>
        )}
      </div>
    )
  };
  const baseList = dataList.filter(item => {
    if (filterType === 'all') return true;
    return item.type === filterType;
  });
  // 实际值存储项在"运行数据"和"全部"下都展示
  const actItems = actListData.map((rec) => ({
    id: `act-${rec.id}`,
    storeId: rec.id, // 真实 id，用于调用 getActValue 详情接口
    type: "actual",
    isFixed: true,
    name: rec.name,
    label: rec.name,
  }));
  const filteredList = (filterType === 'actual' || filterType === 'all') ? [...actItems, ...baseList] : baseList;

  return (
    <div className="wrapper">
      {/* 左侧：设计值 */}
      <div className="panel">
        <div className="filter-tabs">
          <button
            className={`filter-btn ${filterType === 'all' ? 'active' : ''}`}
            onClick={() => setFilterType('all')}
          >
            全部
          </button>
          <button
            className={`filter-btn ${filterType === 'design' ? 'active' : ''}`}
            onClick={() => setFilterType('design')}
          >
            设计值
          </button>
          <button
            className={`filter-btn ${filterType === 'actual' ? 'active' : ''}`}
            onClick={() => setFilterType('actual')}
          >
            运行数据
          </button>
        </div>
        {(filterType === "actual" || filterType === "all") && (
          <div style={{ marginBottom: 8 }}>
            {/* 查询时间段数据（独立组件） */}
            <div style={{ fontSize: 12, color: "#888", marginBottom: 4 }}>查询时间段数据</div>
            <DatePicker.RangePicker
              // 只选到小时：时间面板只保留“时”一列，选完取整点（提交格式仍为 YYYY-MM-DDTHH:mm:ss）
              showTime={{ format: "HH" }}
              format="YYYY-MM-DD HH:00"
              size="small"
              style={{ width: "100%" }}
              value={queryRange}
              onChange={(v) =>
                setQueryRange(
                  v
                    ? [v[0]?.startOf("hour") ?? null, v[1]?.startOf("hour") ?? null]
                    : null
                )
              }
              placeholder={["开始时间", "结束时间"]}
            />
            <Button
              size="small"
              type="primary"
              ghost
              loading={queryLoading}
              onClick={handleQueryConfirm}
              block
              style={{ marginTop: 4 }}
            >
              查询
            </Button>
          </div>
        )}
        {loading ? (
          <div className="emptyTip">
            <Spin />
          </div>
        ) : filteredList.length === 0 ? (
          <div className="emptyTip">暂无{filterType === 'design' ? '设计值' : '运行数据'}</div>
        ) : (
          filteredList.map(renderListItem)
        )}
      </div>

      <Drawer
        open={drawOpen}
        onOpenChange={setDrawOpen}
        title={null}
        // triggerText="点击打开"
        width={taskListWidth ? `calc(100vw - ${taskListWidth}px)` : "calc(100vw - 300px)"}
        children={
          // <DesignValue />
          // selectedItem && (<DesignValue
          //   values={selectedItem?.values}   // 传递 values
          //   item={selectedItem}              // 传递整个item（备用）
          // />)
          selectedItem && (
            selectedItem.type === "actual" ? (
              <ActValue
                item={selectedItem}
                data={realtimeData}
                hourlyResults={hourlyResults}
                onCreated={handleActCreated}
              />
            ) : (
              <DesignValue
                values={selectedItem?.values}   // 传递 values
                item={selectedItem}              // 传递整个item（备用）
              />
            )
          )
        }
      />
    </div>
  );
};

export default DesignTree;